export const TIPO_ENTIDAD_CLIENTE = 'CLIENTE'

export const TIPO_ENTIDAD_EMPRESA = 'EMPRESA'

export const MOTIVO_CODIGOS_ESTABLECIMIENTO = 'CODIGOS_ESTABLECIMIENTO_MH'

export interface VerificacionDato {
  idverificaciondato: number
  tipoentidad: string
  identidad: number
  codigoempresa: string
  nombre: string
  documento: string
  codigomotivo: string
  titulo: string
  mensaje: string
  querevisar: string
  detalle: string
  pendiente: boolean
  fechadeteccion: string
  fecharevision: string
  usuariorevision: string
  observacionrevision: string
  versionhacienda: string
}

export interface ResultadoRevisionVerificacion {
  exitoso: boolean
  mensaje: string
}
